import axios from "axios";

export function formatLocaleDate(date) {
  const tempDate = new Date(date);
  let month = "" + (tempDate.getMonth() + 1);
  let day = "" + tempDate.getDate();
  let year = tempDate.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export function APICall(formik, baseUrl, handleOpen) {
  axios
    .get(baseUrl + "sendEntryorUpdate", {
      params: {
        plantId: formik.values.plantId,
        lastName: formik.values.lastName,
        genus: formik.values.genus,
        species: formik.values.species,
        dateEntered: formik.values.dateEntered,
        dateObserved: formik.values.dateObserved,
        breakingLeafBuds: formik.values.breakingLeafBuds,
        leafObserved: formik.values.leafObserved,
        leafColorObserved: formik.values.leafColorObserved,
        leafIncreasingSize: formik.values.leafIncreasingSize,
        leafFallingObserved: formik.values.leafFallingObserved,
        flowerBudsObserved: formik.values.flowerBudsObserved,
        flowerOpenObserved: formik.values.flowerOpenObserved,
        flowerPollenObserved: formik.values.flowerPollenObserved,
        fruitObserved: formik.values.fruitObserved,
        fruitDropObserved: formik.values.fruitDropObserved,
        fruitRipeObserved: formik.values.fruitRipeObserved,
        leafIntensity: formik.values.leafIntensity,
        breakingLeafBudsIntensity: formik.values.breakingLeafBudsIntensity,
        leafIncreasingInSizeIntensity:
          formik.values.leafIncreasingInSizeIntensity,
        leafColorIntensity: formik.values.leafColorIntensity,
        leafFallingObservedIntensity:
          formik.values.leafFallingObservedIntensity,
        flowerBudsIntensity: formik.values.flowerBudsIntensity,
        flowerOpenIntensity: formik.values.flowerOpenIntensity,
        flowerPollenReleaseIntensity:
          formik.values.flowerPollenReleaseIntensity,
        fruitIntensity: formik.values.fruitIntensity,
        fruitDropIntensity: formik.values.fruitDropIntensity,
        fruitRipeIntensity: formik.values.fruitRipeIntensity,
        comments: formik.values.comments,
      },
    })
    .then((res) => {
      if (res.data === "23505") {
        //error code pk violation
        if (
          window.confirm(
            "Already exists in the database. \n\n Do you want to update this record?"
          )
        ) {
          alert("Updating " + res.data);
          axios
            .get(baseUrl + "UpdateRecord", {
              params: {
                plantId: formik.values.plantId,
                lastName: formik.values.lastName,
                genus: formik.values.genus,
                species: formik.values.species,
                dateEntered: formik.values.dateEntered,
                dateObserved: formik.values.dateObserved,
                breakingLeafBuds: formik.values.breakingLeafBuds,
                leafObserved: formik.values.leafObserved,
                leafColorObserved: formik.values.leafColorObserved,
                leafIncreasingSize: formik.values.leafIncreasingSize,
                leafFallingObserved: formik.values.leafFallingObserved,
                flowerBudsObserved: formik.values.flowerBudsObserved,
                flowerOpenObserved: formik.values.flowerOpenObserved,
                flowerPollenObserved: formik.values.flowerPollenObserved,
                fruitObserved: formik.values.fruitObserved,
                fruitDropObserved: formik.values.fruitDropObserved,
                fruitRipeObserved: formik.values.fruitRipeObserved,
                leafIntensity: formik.values.leafIntensity,
                breakingLeafBudsIntensity:
                  formik.values.breakingLeafBudsIntensity,
                leafIncreasingInSizeIntensity:
                  formik.values.leafIncreasingInSizeIntensity,
                leafColorIntensity: formik.values.leafColorIntensity,
                leafFallingObservedIntensity:
                  formik.values.leafFallingObservedIntensity,
                flowerBudsIntensity: formik.values.flowerBudsIntensity,
                flowerOpenIntensity: formik.values.flowerOpenIntensity,
                flowerPollenReleaseIntensity:
                  formik.values.flowerPollenReleaseIntensity,
                fruitIntensity: formik.values.fruitIntensity,
                fruitDropIntensity: formik.values.fruitDropIntensity,
                fruitRipeIntensity: formik.values.fruitRipeIntensity,
                comments: formik.values.comments,
              },
            })
            .then((res) => {
              alert(res.data);
            });
        } else {
          alert("No changes made");
        }
      } else {
        alert("Your entry has been submitted! " + res.data);
      }
      document.location.reload();
    })
    .catch((err) => {
      alert("Fatal error occurred. The form will be erased. Please try again.");
      document.getElementById("DataEntryForm").reset();
      document.location.reload();
    });
}

//need to continue editing this function
export function onClickObserved(formik, idNumString, name, value) {
  let onClick;

  switch (true) {
    // For example if Leaf Observed Yes is selected, then set all associated formik values to null,
    // and show associated values as deselected or "Select an option"

    case name === "breakingLeafBuds":
      onClick = () => {
        formik.values.breakingLeafBuds = value;
        formik.values.breakingLeafBudsIntensity = "";

        document.getElementById(
          "breakingLeafBuds" + idNumString
        ).checked = true;
        document.getElementById("breakingLeafBudsIntensity").selectedIndex = 0;
      };
      break;
    case (name === "leafObserved" && value === "y") ||
      (name === "leafObserved" && value === "?"):
      const assocQuestionList1 = [
        "leafColorObserved",
        "leafIncreasingSize",
        "leafFallingObserved",
      ];
      const assocIntensityList1 = [
        "leafIntensity",
        "leafColorIntensity",
        "leafIncreasingInSizeIntensity",
      ];

      onClick = () => {
        formik.values.leafColorObserved = "";
        formik.values.leafIncreasingSize = "";
        formik.values.leafFallingObserved = "";
        formik.values.leafIntensity = "";
        formik.values.leafColorIntensity = "";
        formik.values.leafIncreasingInSizeIntensity = "";

        for (let i = 0; i < assocQuestionList1.length; i++) {
          for (let j = 1; j <= 4; j++) {
            document.getElementById(assocQuestionList1[i] + j).checked = false;
          }
        }

        for (let i = 0; i < assocIntensityList1.length; i++) {
          document.getElementById(assocIntensityList1[i]).selectedIndex = 0;
        }
      };

      break;

    case name === "leafObserved":
      onClick = () => {
        formik.values.leafColorObserved = value;
        formik.values.leafIncreasingSize = value;
        formik.values.leafFallingObserved = value;
        formik.values.leafIntensity = "";
        formik.values.leafColorIntensity = "";
        formik.values.leafIncreasingInSizeIntensity = "";
        document.getElementById(
          "leafColorObserved" + idNumString
        ).checked = true;
        document.getElementById(
          "leafIncreasingSize" + idNumString
        ).checked = true;
        document.getElementById(
          "leafFallingObserved" + idNumString
        ).checked = true;
        document.getElementById("leafIntensity").selectedIndex = 0;
        document.getElementById("leafColorIntensity").selectedIndex = 0;
        document.getElementById(
          "leafIncreasingInSizeIntensity"
        ).selectedIndex = 0;
      };
      break;
    case name === "leafIncreasingSize":
      onClick = () => {
        formik.values.leafIncreasingSize = value;
        formik.values.leafIncreasingInSizeIntensity = "";

        document.getElementById(
          "leafIncreasingSize" + idNumString
        ).checked = true;
        document.getElementById(
          "leafIncreasingInSizeIntensity"
        ).selectedIndex = 0;
      };
      break;
    case name === "leafColorObserved":
      onClick = () => {
        formik.values.leafColorObserved = value;
        formik.values.leafColorIntensity = "";

        document.getElementById(
          "leafColorObserved" + idNumString
        ).checked = true;
        document.getElementById("leafColorIntensity").selectedIndex = 0;
      };
      break;
    case (name === "flowerBudsObserved" && value === "y") ||
      (name === "flowerBudsObserved" && value === "?"):
      const assocQuestionList2 = ["flowerOpenObserved", "flowerPollenObserved"];
      const assocIntensityList2 = [
        "flowerBudsIntensity",
        "flowerOpenIntensity",
        "flowerPollenReleaseIntensity",
      ];
      onClick = () => {
        formik.values.flowerBudsObserved = "";
        formik.values.flowerOpenObserved = "";
        formik.values.flowerPollenObserved = "";
        formik.values.flowerBudsIntensity = "";
        formik.values.flowerOpenIntensity = "";
        formik.values.flowerPollenReleaseIntensity = "";

        for (let i = 0; i < assocQuestionList2.length; i++) {
          for (let j = 1; j <= 4; j++) {
            document.getElementById(assocQuestionList2[i] + j).checked = false;
          }
        }
        for (let i = 0; i < assocIntensityList2.length; i++) {
          document.getElementById(assocIntensityList2[i]).selectedIndex = 0;
        }
      };

      break;
    case name === "flowerBudsObserved":
      onClick = () => {
        formik.values.flowerBudsObserved = value;
        formik.values.flowerOpenObserved = value;
        formik.values.flowerPollenObserved = value;
        formik.values.flowerBudsIntensity = "";
        formik.values.flowerOpenIntensity = "";
        formik.values.flowerPollenReleaseIntensity = "";
        document.getElementById(
          "flowerOpenObserved" + idNumString
        ).checked = true;
        document.getElementById(
          "flowerPollenObserved" + idNumString
        ).checked = true;
        document.getElementById("flowerBudsIntensity").selectedIndex = 0;
        document.getElementById("flowerOpenIntensity").selectedIndex = 0;
        document.getElementById(
          "flowerPollenReleaseIntensity"
        ).selectedIndex = 0;
      };
      break;
    case name === "flowerOpenObserved":
      onClick = () => {
        formik.values.flowerOpenObserved = value;
        formik.values.flowerOpenIntensity = "";

        document.getElementById(
          "flowerOpenObserved" + idNumString
        ).checked = true;
        document.getElementById("flowerOpenIntensity").selectedIndex = 0;
      };
      break;
    case name === "flowerPollenObserved":
      onClick = () => {
        formik.values.flowerPollenObserved = value;
        formik.values.flowerPollenReleaseIntensity = "";

        document.getElementById(
          "flowerPollenObserved" + idNumString
        ).checked = true;
        document.getElementById(
          "flowerPollenReleaseIntensity"
        ).selectedIndex = 0;
      };
      break;
    case (name === "fruitObserved" && value === "y") ||
      (name === "fruitObserved" && value === "?"):
      const assocQuestionList3 = ["fruitRipeObserved", "fruitDropObserved"];
      const assocIntensityList3 = [
        "fruitIntensity",
        "fruitRipeIntensity",
        "fruitDropIntensity",
      ];
      onClick = () => {
        formik.values.fruitRipeObserved = "";
        formik.values.fruitDropObserved = "";
        formik.values.fruitIntensity = "";
        formik.values.fruitRipeIntensity = "";
        formik.values.fruitDropIntensity = "";

        for (let i = 0; i < assocQuestionList3.length; i++) {
          for (let j = 1; j <= 4; j++) {
            document.getElementById(assocQuestionList3[i] + j).checked = false;
          }
        }
        for (let i = 0; i < assocIntensityList3.length; i++) {
          document.getElementById(assocIntensityList3[i]).selectedIndex = 0;
        }
      };
      break;
    case name === "fruitObserved":
      onClick = () => {
        formik.values.fruitRipeObserved = value;
        formik.values.fruitDropObserved = value;
        formik.values.fruitIntensity = "";
        formik.values.fruitRipeIntensity = "";
        formik.values.fruitDropIntensity = "";
        document.getElementById(
          "fruitRipeObserved" + idNumString
        ).checked = true;
        document.getElementById(
          "fruitDropObserved" + idNumString
        ).checked = true;
        document.getElementById("fruitIntensity").selectedIndex = 0;
        document.getElementById("fruitRipeIntensity").selectedIndex = 0;
        document.getElementById("fruitDropIntensity").selectedIndex = 0;
      };
      break;
    case name === "fruitRipeObserved":
      onClick = () => {
        formik.values.fruitRipeObserved = value;
        formik.values.fruitRipeIntensity = "";

        document.getElementById(
          "fruitRipeObserved" + idNumString
        ).checked = true;
        document.getElementById("fruitRipeIntensity").selectedIndex = 0;
      };
      break;
    case name === "fruitDropObserved":
      onClick = () => {
        formik.values.fruitDropObserved = value;
        formik.values.fruitDropIntensity = "";

        document.getElementById(
          "fruitDropObserved" + idNumString
        ).checked = true;
        document.getElementById("fruitDropIntensity").selectedIndex = 0;
      };
      break;

    default:
      break;
  }
  return onClick;
}

export function onClickPopulateFields(baseUrl, formik, { plantId, genus }) {
  console.log(
    "Entered onClickPopulateFields method\n baseUrl: ",
    baseUrl,
    "\nplantid: ",
    plantId,
    "\ngenus: ",
    genus
  );

  formik.values.plantId = plantId;
  document.getElementById("plantId").value = plantId;

  if (formik.values.plantId !== "") {
    axios
      .get(baseUrl + "getTreeInfo", {
        params: {
          plantid: plantId,
        },
      })

      .then((resCollection) => {
        var fields = resCollection.data[0].Taxon.split(" ");
        var collection = fields[0];

        var genus = collection;
        var species = fields.slice(1).join(" "); //fields[1];

        formik.values.genus = genus;
        formik.values.species = species;
        document.getElementById("genus").value = genus;
        document.getElementById("species").value = species;
        axios.get(baseUrl + "getName", {
          params: {
            plantid: formik.values.plantId,
            genus: formik.values.genus,
          },
        });
      })
      .catch((error) => {
        console.log("ERROR: Check Collection:", error);
        alert("Tree not in collection");
      });
  }
}

export function onClickPopulateLists(baseUrl, ObserverID) {
  return axios
    .get(baseUrl + "getObsList", {
      params: {
        ObserverID: ObserverID,
      },
    })
    .catch((err) => {
      console.log("onClickPopulateLists error: ", err);
    });
}
